"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUserDataCriticalActionCodeListener = exports.setRefreshPermissionsListener = exports.setFetchPermissionsListener = exports.setFetchUserDataListener = exports.removeUserDataCriticalActionListener = exports.setUserDataCriticalActionListener = exports.setIsDataCriticalActionIncorrectCodeListener = exports.setCriticalActionErrorListener = exports.setUserDataCriticalActionCodeListener = exports.setUserDataListener = exports.setAuthentificateUserListener = void 0;
var databus_1 = require("@portals/databus");
var constants_1 = require("./constants");
var setAuthentificateUserListener = function (listener) {
    new databus_1.Databus({ name: constants_1.AUTHENTIFICATE_USER_STATE }).addEventListener({
        listener: listener,
    });
};
exports.setAuthentificateUserListener = setAuthentificateUserListener;
var setUserDataListener = function (listener) {
    new databus_1.Databus({ name: constants_1.USER_DATA }).addEventListener({
        listener: listener,
    });
};
exports.setUserDataListener = setUserDataListener;
var setUserDataCriticalActionCodeListener = function (listener) {
    new databus_1.Databus({ name: constants_1.CRITICAL_ACTION_CODE }).addEventListener({
        listener: listener,
    });
};
exports.setUserDataCriticalActionCodeListener = setUserDataCriticalActionCodeListener;
var setCriticalActionErrorListener = function (listener) {
    new databus_1.Databus({
        name: constants_1.CRITICAL_ACTION_ERROR,
    }).addEventListener({
        eventId: constants_1.CRITICAL_ACTION_ERROR,
        listener: listener,
    });
    return function () {
        new databus_1.Databus({ name: constants_1.CRITICAL_ACTION_ERROR }).removeEventListener({
            eventId: constants_1.CRITICAL_ACTION_ERROR,
        });
    };
};
exports.setCriticalActionErrorListener = setCriticalActionErrorListener;
var setIsDataCriticalActionIncorrectCodeListener = function (listener) {
    new databus_1.Databus({ name: constants_1.INCORRECT_CODE }).addEventListener({
        listener: listener,
    });
};
exports.setIsDataCriticalActionIncorrectCodeListener = setIsDataCriticalActionIncorrectCodeListener;
var setUserDataCriticalActionListener = function (listener) {
    new databus_1.Databus({ name: constants_1.USER_CRITICAL_ACTION }).addEventListener({
        listener: listener,
    });
};
exports.setUserDataCriticalActionListener = setUserDataCriticalActionListener;
var removeUserDataCriticalActionListener = function () {
    new databus_1.Databus({ name: constants_1.USER_CRITICAL_ACTION }).removeEventListener();
};
exports.removeUserDataCriticalActionListener = removeUserDataCriticalActionListener;
var setFetchUserDataListener = function (listener) {
    new databus_1.Databus({ name: constants_1.FETCH_USER_DATA }).addEventListener({
        listener: listener,
    });
};
exports.setFetchUserDataListener = setFetchUserDataListener;
var setFetchPermissionsListener = function (listener) {
    new databus_1.Databus({ name: constants_1.FETCH_PERMISSIONS }).addEventListener({
        listener: listener,
    });
};
exports.setFetchPermissionsListener = setFetchPermissionsListener;
var setRefreshPermissionsListener = function (listener) {
    new databus_1.Databus({ name: constants_1.REFRESH_PERMISSIONS }).addEventListener({
        listener: listener,
    });
};
exports.setRefreshPermissionsListener = setRefreshPermissionsListener;
var removeUserDataCriticalActionCodeListener = function () {
    new databus_1.Databus({ name: constants_1.CRITICAL_ACTION_CODE }).removeEventListener();
};
exports.removeUserDataCriticalActionCodeListener = removeUserDataCriticalActionCodeListener;
